export const isDialogOpen = (id, dialogs) => Boolean(dialogs.find((item) => item.id === id, id));
//# sourceMappingURL=isDialogOpen.js.map